<template>
  <div class="notice_detail">
    <div class="title">
      <div class="tit">
        {{noticeDesc.noticeTitle}}
      </div>
      <div class="time">
        省整治办 {{noticeDesc.createTime}}
      </div>
    </div>
    <div class="content">
      <div class="txt">
        {{noticeDesc.noticeContent}}
      </div>
      <div class="files">
        <div class="file_item" v-for="item in noticeDesc.fileResVOS" :key="item.id">
        <div class="file_msg" @click="openFile(item)">
          <img v-if="item.fileType ==='exl'" src="@/assets/appraise/ic_exl.png" alt />
          <img v-if="item.fileType ==='doc'" src="@/assets/appraise/ic_doc.png" alt />
          <img v-if="item.fileType ==='pdf'" src="@/assets/appraise/ic_pdf.png" alt />
          <p class="file_name">
            <span>{{ item.fileName }}{{'.'+item.fileType}}</span>
          </p>
        </div>
        <div class="file_size">{{item.fileSize}}</div>
      </div>
      </div>
    </div>
     <modalIframe :url="iframeurl"></modalIframe>
  </div>
</template>

<script>
import api from "@/service/modules/appraiseNew.js";
import modalIframe from '../appraiseNew/components/modalIframe';
export default {
  components:{
    modalIframe
  },
  data() {
    return {
      noticeDesc: {},
      iframeurl:''
    }
  },
  created() {
    this.queryDetail();
    this.updateNotice();
  },
  methods: {
    // 获取详情
    queryDetail() {
      let params = {
        id: this.$route.query.id
      }
      api.getNoticeDesc(params).then(res => {
        if(res.ret === 0) {
          this.noticeDesc = res.data;
        }
      })
    },
    /**
     * @description: 打开附件
     * @param { item } object
     */
    openFile(item) {
      const _this = this;
      const str = navigator.userAgent.toLowerCase();
      const ver = str.match(/cpu iphone os (.*?) like mac os/);
      if (!ver) {
        console.log("---安卓进来这里url:", item.fileUrl);
        // this.$toast('当前暂不支持预览附件')
        // console.log('不是苹果')
       
        this.iframeurl = item.fileUrl
      } else {
        window.yyn.invokeJSB(
          "openWindow",
          {
            openUrl: item.fileUrl,
            isFullScreen: 0,
            setTitle: name,
            needLoading: 1,
          },
          (cb) => {
            console.log(cb, "callback");
          }
        );
      }
       setTimeout( ()=>{
        _this.iframeurl = ''
      }, 100)
    },
    // 改变通告状态
    updateNotice() {
      let params = {
        id: this.$route.query.id
      }
      api.updateNotice(params).then(res => {
        
      })
    }
  }
}
</script>

<style scoped lang="less">
  .notice_detail {
    &>.title {
      margin-top: 12px;
      padding: 0 16px;
      border-bottom: 1px solid #EDEDED;
      .tit {
        font-size: 16px;
        color: #333;
        font-weight: 500;
        line-height: 24px;
        word-break: break-all;
      }
      .time {
        margin-top: 8px;
        padding-bottom: 16px;
        color: 12px;
        color: #999;
      }
    }
    .content {
      padding: 11px 16px 0;
      .txt {
        padding-bottom: 16px;
        color: #333;
        font-size: 14px;
        line-height: 24px;
      }
      .files .file {
        display: flex;
        justify-content: space-between;
        align-content: center;
        padding: 8px 0;
      }
      .files .file img {
        display: inline-block;
        margin-right: 12px;
        width: 34px;
        height: 38px;
      }
      .files .file .title {
        display: inline-block;
        width: 232px;
        font-size: 14px;
        line-height: 22px;
        color: #333;
        word-break: break-all;
      }
      .files .file .size {
        color: #999;
        font-size: 12px;
        line-height: 46px;
      }
    }
  }
  .file_item {
  display: flex;
  box-sizing: border-box;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 15px;
  .file_msg {
    flex: 1;
    display: flex;
    align-items: center;
  }
  .file_msg img {
    margin-right: 12px;
    width: 34px;
    height: 38px;
  }
  .file_msg p {
    font-size: 14px;
    color: #333;
    span {
      line-height: 20px;
      word-break: break-word;
    }
  }
  .file_size {
    font-size: 12px;
    color: #999;
  }
  .delImg {
    box-sizing: border-box;
    line-height: 38px;
    margin-left: 5px;
    margin-right: 10px;
  }
  .delImg img {
    width: 20px;
  }
}
</style>